/* eslint-disable jsx-a11y/label-has-associated-control */

/* eslint-disable react/require-default-props */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';
import skaler from 'skaler';

import { toBase64, assertFileValid, getImageSize } from '../../lib/utils';

import PlusIcon from '../icons/Plus';

import styles from '../../styles/partials/upload-form.module.css';

const propTypes = {
    onUpload: PropTypes.func,
    className: PropTypes.string,
};

function UploadForm({ onUpload = null, className = null }) {
    const [loading, setLoading] = useState(false);

    const onChange = useCallback(async (event) => {
        if (typeof event.target.files === 'undefined' || event.target.files.length === 0) {
            return;
        }
        const [file = null] = event.target.files || [];
        if (!assertFileValid(file)) {
            return;
        }

        setLoading(true);

        const image = await skaler(file, { width: 320 });
        const base64 = await toBase64(image);
        const size = await getImageSize(base64);

        const { name = 'default' } = file || {};
        onUpload({ name, base64, size });

        setLoading(false);
    }, []);

    return (
        <form
            className={classNames([
                styles.container,
                styles.gradient,
                { [styles.disabled]: loading, [className]: className !== null },
            ])}
            method="post"
            encType="multipart/form-data"
            onSubmit={onUpload}
        >
            <input
                className={styles.input}
                name="files"
                type="file"
                accept="image/*"
                onChange={onChange}
                disabled={loading}
            />
            <label className={styles.cover} htmlFor="files">
                <PlusIcon className={styles.icon} />
            </label>
            {/* <button
                className={classNames([
                    styles.container,
                    styles.gradient,
                    { [className]: className !== null },
                ])}
                type="submit"
            >
                UploadForm
            </button> */}
        </form>
    );
}

UploadForm.propTypes = propTypes;

export default UploadForm;
